<template><div><h1>VUX V2.3.2 发布日志</h1>
<h2><a href="/zh-CN/components/checker.html">Checker</a></h2>
<ul><li>[enhance] 支持在单选的情况下第二次点击时变成不选中当前项 #1468</li>
</ul>
<h2><a href="/zh-CN/components/group.html">Group</a></h2>
<ul><li>[feature] gutter 属性允许为数字类型</li>
</ul>
<h2><a href="/zh-CN/components/x-number.html">XNumber</a></h2>
<ul><li>[fix] 修复 min 不存在的判断 #1459</li>
</ul>
<h2><a href="/zh-CN/components/date.html">Date</a></h2>
<ul><li>[enhance] 无时间参数时返回字符串</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.2 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.2-231.vue?8eb05352